import { render } from "./ArticlesSection.vue?vue&type=template&id=a3f6129a&scoped=true"
import script from "./ArticlesSection.vue?vue&type=script&lang=js"
export * from "./ArticlesSection.vue?vue&type=script&lang=js"

import "./ArticlesSection.vue?vue&type=style&index=0&id=a3f6129a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3f6129a"]])

export default __exports__